import { makeAutoObservable } from "mobx";

export enum BreakpointEnum {
  xl = "xl", //超大屏幕，以 1698px 做设计，≥ 1698px
  lg = "lg", //正常屏幕，以 1400px 做设计， 1200px < normal < 1698px
  md = "md", //稍小屏幕，以 1020px 做设计， 768px < md ≤ 1200px
  sm = "sm", //移动端屏幕，以 375px 做设计，≤ 768px
}

export default class App {
  breakpoint: BreakpointEnum = BreakpointEnum.lg;
  windowInnerWidth: number = 0;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  get isH5(): boolean {
    return this.breakpoint === BreakpointEnum.sm;
  } //是否是H5布局

  updateState(payload) {
    for (const va in payload) {
      this[va] = payload[va];
    }
  }
}
